export const exportToCSV= (data,selectedFields) => {
    // Extract headers from the data
    const header = selectedFields;
  
    // Map data to CSV rows
    const rows = data.map(row => 
      header.map(fieldName => 
        // Ensure that the data is correctly formatted and escape any commas or special characters
        `"${row[fieldName] ? row[fieldName].toString().replace(/"/g, '""') : ''}"`
      ).join(',')
    );
  
    // Add header to the top of the CSV file
    rows.unshift(header.join(','));
  
    // Join all rows together to form the CSV content
    const csvContent = rows.join('\r\n');
  
    // Create a Blob with CSV content and prepare the download link
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  
    // Create a download link and trigger the download
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', 'data.csv');
      link.click();
      URL.revokeObjectURL(url);
    }
  };